module.exports = __webpack_public_path__ + "img/leftCircle.c16fea5.png";